/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
export enum FeatureFlag {
  newPostbackUi = "newPostbackUi",
  mobileVideosPromoTool = "mobileVideosPromoTool",
}
